import queryString from 'query-string';

export const getBookingUrl = (propertyCode, trackingParams, selectedFilters, locale = 'de') => {

    const bookingParams = buildBookingParams(selectedFilters);
    const trackingInfo = buildTrackingParams(trackingParams);

    const params = {
        'skd-property-code': propertyCode,
        'skd-language-code': locale,
        'skd-price-type': 'withInformativeTaxesAndFees',
        ...bookingParams,
        ...trackingInfo
    };

    let baseUrl = 'https://booking.urlaubambauernhof.at/property/';

    if(window._config.pzg) {
        baseUrl = 'https://booking.privatzugast.at/property/';
    } else {
        params['skd-channel-id'] = 'AT_UAB';
    }

    const queryParams = queryString.stringify(params, {arrayFormat: 'bracket'});
    return `${baseUrl}${propertyCode}?${queryParams}`;
};

export const getDetailPageUrl = (baseUrl, selectedFilters) => {
    // keep only the args we actually need for the detail page
    const params = Object.keys(selectedFilters).reduce((acc, key) => {
        if (['checkin', 'checkout', 'roomTypes'].includes(key) || key.startsWith('adults-') || key.startsWith('childs-') || key.startsWith('childAge')) {
            acc[key] = selectedFilters[key];
        }
        return acc;
    }, {});
    const queryParams = queryString.stringify(params, {
        arrayFormat: 'bracket',
        skipNull: true,
        skipEmptyString: true,
    });
    return queryParams ? `${baseUrl}?${queryParams}` : baseUrl;
};

const buildBookingParams = (selectedFilters) => {
    const params = {};

    addAdultsParams(params, selectedFilters);
    addChildrenParams(params, selectedFilters);

    if (selectedFilters.checkin) {
        params['skd-checkin'] = selectedFilters.checkin;
    }

    if (selectedFilters.checkout) {
        params['skd-checkout'] = selectedFilters.checkout;
    }

    return params;
};
const addAdultsParams = (params, selectedFilters) => {
    let roomCount = 0;
    while (`adults-${roomCount}` in selectedFilters) {
        params[`adult_room${roomCount + 1}`] = selectedFilters[`adults-${roomCount}`];
        roomCount++;
    }
    if (roomCount) {
        params['skd-total-rooms'] = roomCount;
    }
};
const addChildrenParams = (params, selectedFilters) => {
    const addChildCountToParams = (roomIndex, childCount) => {
        params[`child_room${roomIndex + 1}`] = childCount;
    };
    const addChildAgesToParams = (roomIndex, childCount) => {
        for (let i = 1; i <= childCount; i++) {
            const childAgeKey = `childAge${roomIndex}-${i}`;
            const age = selectedFilters[childAgeKey] || 0;
            const ageParamKey = `child_room${roomIndex + 1}_age${age}`;
            params[ageParamKey] = (params[ageParamKey] || 0) + 1;
        }
    };

    let currentRoom = 0;
    while (`childs-${currentRoom}` in selectedFilters) {
        const childCount = selectedFilters[`childs-${currentRoom}`];
        addChildCountToParams(currentRoom, childCount);
        addChildAgesToParams(currentRoom, childCount);
        currentRoom++;
    }
};
const buildTrackingParams = (trackingParams) => {
    const trackingInfo = {};

    Object.entries(trackingParams).forEach(([key, value]) => {
        if (value) {
            trackingInfo[`tracking_${key}`] = value;
        }
    });

    return trackingInfo;
};

